module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene"
  }, [_c('div', {
    staticClass: "boo",
    style: (_vm.booStyle)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-41d3f06e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SacralCircle.vue
// module id = 123
// module chunks = 1